import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCreative = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 14,
	fill: "none",
	viewBox: "0 0 14 14",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#49454F",
		d: "M1.556 14c-.428 0-.794-.152-1.1-.457A1.498 1.498 0 0 1 0 12.444V1.556c0-.428.152-.794.457-1.1C.762.153 1.127 0 1.556 0h10.888c.428 0 .794.152 1.1.457.304.305.456.67.456 1.099v10.888c0 .428-.152.794-.457 1.1-.305.304-.67.456-1.099.456H1.556Zm.777-3.111h9.334L8.75 7l-2.333 3.111-1.75-2.333-2.334 3.11Z"
	})
});
export { SvgCreative as ReactComponent };
